import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';

// Icons
import DescriptionIcon from '@mui/icons-material/Description';
import SourceIcon from '@mui/icons-material/Source';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import Gstprevalidation from './Sales/GstPreValidation/Gstprevalidation';
import GSTR2BPrevalidaion from "./Purchase/GSTR2_Prevalidation/GSTR2BPrevalidation";
import GstrPanValidationTables from '../ARC_Reports/GstrPanValidation/gstrPanValidation';


export default function ArcDataValidation() {
    const history = useHistory();
    const location = useLocation();
    const [tabIndex, setTabIndex] = useState(0);
    const [sitemapData, setSitemapData] = useState(null);

    useEffect(() => {
        const storedSitemap = localStorage.getItem("sitemap");
        if (storedSitemap) {
            try {
                const parsed = JSON.parse(storedSitemap);
                setSitemapData(parsed);
            } catch (e) {
                console.error("Failed to parse sitemap from localStorage", e);
                setSitemapData(null);
            }
        }
    }, []);

    const salesAccess = sitemapData?.["ARC RECONCILLIATION"]?.SALES || [];
    const purchaseAccess = sitemapData?.["ARC RECONCILLIATION"]?.PURCHASE || [];

    const dataValidationTabs = [
        salesAccess.includes("GSTR1-PREVALIDATION") && {
            label: 'GSTR-1',
            icon: <DescriptionIcon />,
            path: '/gstPreValidation',
            component: <Gstprevalidation />
        },
        purchaseAccess.includes("GSTR2-PREVALIDATION") && {
            label: 'GSTR-2',
            icon: <SourceIcon />,
            path: '/Gstr2bPrevalidation',
            component: <GSTR2BPrevalidaion />
        },
        (sitemapData && sitemapData?.["GSTIN & PAN VALIDATION"]) && {
            label: 'GSTN/PAN Validation',
            icon: <VerifiedUserIcon />,
            path: '/GstrPanValidation',
            component: <GstrPanValidationTables />
        }
    ].filter(Boolean);

    useEffect(() => {
        if (!dataValidationTabs.length) return;

        const foundIndex = dataValidationTabs.findIndex(tab => location.pathname === tab.path);

        if (foundIndex !== -1) {
            setTabIndex(foundIndex);
        } else {
            setTabIndex(0);
            history.replace(dataValidationTabs[0].path);
        }
    }, [location.pathname, dataValidationTabs, history]);


    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        const selectedTab = dataValidationTabs[newValue];
        if (selectedTab?.path) {
            history.push(selectedTab.path);
        }
    };

    return (
        <Box sx={{ fontFamily: "'Inter', sans-serif", width: '100%' }}>
            {/* Toggle Button Group */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    gap: 2,
                    mb: 4,
                }}
            >
                {dataValidationTabs.length > 0 ? (
                    <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="Sales/Purchase Tabs"
                        sx={{
                            backgroundColor: '#ffffff',
                            borderRadius: '30px',
                            p: '4px',
                            maxWidth: '80%',
                            overflowX: 'auto',
                            '.MuiTab-root': {
                                width:'auto',
                                textTransform: 'uppercase',
                                fontWeight: 550,
                                fontFamily: '"Dosis", sans-serif',
                                letterSpacing: '1px',
                                fontSize: '13px',
                                minHeight: '35px',
                                borderRadius: '20px',
                                px: 2.5,
                                py: 0.9,
                                color: '#212121',
                                '&:hover': {
                                    backgroundColor: 'var(--sub-btn-color)',
                                    color: '#fff !important',
                                },
                            },
                            '.Mui-selected': {
                                backgroundColor: 'var(--sub-btn-color)',
                                color: '#fff !important',
                            },
                            '.MuiTabs-indicator': {
                                display: 'none',
                            },
                            '.MuiTabs-scrollButtons': {
                                backgroundColor: 'var(--sub-btn-color)',
                                borderRadius: '50%',
                                '&.Mui-disabled': {
                                  opacity: 0.3,
                                },
                              },
                        }}
                    >
                        {dataValidationTabs.map((tab, index) => (
                            <Tab key={index} icon={tab.icon} iconPosition="start" label={tab.label} />
                        ))}
                    </Tabs>
                ) : null}
            </Box>

            {/* Content or Empty Message */}
            {dataValidationTabs.length > 0 ? (
                <Box>{dataValidationTabs[tabIndex]?.component}</Box>
            ) : (
                <Box
                    sx={{
                        textAlign: 'center',
                        mt: 20,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <InfoOutlinedIcon sx={{ fontSize: 64, color: '#90a4ae', mb: 2 }} />
                    <Box sx={{ fontSize: '18px', color: '#607d8b', fontFamily: '"Dosis", sans-serif', }}>
                        Please activate the Data Prevalidation Services to access.
                    </Box>
                </Box>
            )}
        </Box>
    );
}      
